"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const LanguageContext = (0, react_1.createContext)({
    i18n: (x) => x || '',
    translations: {},
});
exports.default = LanguageContext;
